import './read_actual_details';
import './read_proposal';


// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/contracts/index.js